export const withLogic =
  (Component: React.ComponentType<any>): React.FC<any> =>
  (props: any) => {
    return (
      <Component
        {...{
          ...props,
          onSelect: () => {
            props?.onSelect?.(props.internalIndex + 1);
          }
        }}
      />
    );
  };
